import Filters from './Filters'
import FiltersContainer from './FiltersContainer'

export default FiltersContainer

export { Filters, FiltersContainer }
